class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = [];
    this.allSearchForms = [];
    this.onInputFocusBound = this.onInputFocus.bind(this);
    this.onFormResetBound = this.onFormReset.bind(this);
    this.onInputBound = this.onInput.bind(this);
  }

  connectedCallback() {
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.allSearchForms = [...new Set([...this.allSearchInputs].map((input) => input.form).filter(Boolean))];
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('focus', this.onInputFocusBound);
    if (this.allSearchForms.length < 2) return;
    this.allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormResetBound));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInputBound));
  }

  disconnectedCallback() {
    this.input?.removeEventListener('focus', this.onInputFocusBound);
    this.allSearchForms.forEach((form) => form.removeEventListener('reset', this.onFormResetBound));
    this.allSearchInputs.forEach((input) => input.removeEventListener('input', this.onInputBound));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: getMotionSafeBehavior() });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
